import type { Dispatch, SetStateAction } from "react";
import { useIntl } from "react-intl";

import type { IProject } from "@citrine/resources/project";
import type { Team } from "@citrine/resources/team";

import { Select, TextField } from "#src/components/form";

import * as sx from "./common.sx";

export function createEmptyProject(): Omit<IProject, "team"> {
  return {
    id: "",
    name: "",
    description: "",
    created_at: "",
    point_of_contact_id: null,
    scope_id: "",
    status: "",
    created_by: "mock-user-id",
  };
}

export interface ProjectValues extends Omit<IProject, "team"> {
  teamId: string;
}

export function NewProjectDialogContent({
  errorMessage,
  setErrorMessage,
  teams,
  setTeamId,
}: {
  errorMessage: string | undefined;
  setErrorMessage: Dispatch<SetStateAction<string | undefined>>;
  teams: Team[];
  setTeamId: Dispatch<SetStateAction<string>>;
}) {
  const { formatMessage } = useIntl();

  return (
    <>
      {errorMessage ? (
        <sx.Alert severity="error" onClose={() => setErrorMessage(undefined)}>
          {errorMessage}
        </sx.Alert>
      ) : null}
      <Select<ProjectValues>
        data-testid="project-team-select"
        name="teamId"
        label="Team"
        options={teams.map((team) => ({
          value: team.id,
          label: team.name,
        }))}
        onChange={(e) => {
          setTeamId(e.target.value as string);
        }}
        autoFocus
        fullWidth
        required
      />
      <TextField<IProject>
        data-testid="new-project-name"
        name="name"
        label={formatMessage({ id: "projects.dialog.name.label" })}
        fullWidth
        required
      />
      <sx.DescriptionField<IProject>
        data-testid="new-project-description"
        name="description"
        label={formatMessage({ id: "projects.dialog.description.label" })}
        fullWidth
        multiline
        required
        minRows={4}
      />
    </>
  );
}
